// Статус сети для офлайн-состояний UI (offline-first.md §9).
//
// useSyncExternalStore, а не useState + useEffect: значение читается из внешнего
// источника (navigator.onLine), и React обязан видеть его актуальным уже на первом
// рендере — иначе баннер «нет сети» мигает при старте.
//
// Ограничение, о котором нужно помнить: navigator.onLine отвечает лишь «есть ли
// сетевой интерфейс», а не «доходит ли трафик до сервера». На кухонном WiFi это
// разные вещи. Точный статус даёт Capacitor-плагин Network плюс результат реальных
// запросов — подключается в T-007 вместе с sync engine.

import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange: () => void): () => void {
  window.addEventListener('online', onStoreChange);
  window.addEventListener('offline', onStoreChange);

  return () => {
    window.removeEventListener('online', onStoreChange);
    window.removeEventListener('offline', onStoreChange);
  };
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

/** На сервере (SSR/пререндер) считаем, что сеть есть, — офлайн-баннер не должен попадать в HTML. */
function getServerSnapshot(): boolean {
  return true;
}

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
